import { MetricSubType } from '@/proto/metric';

export const SUB_METRIC_OPTIONS = [
  { label: '上报次数', value: MetricSubType.SUB_TYPE_COUNT },
  { label: '上报设备数', value: MetricSubType.SUB_TYPE_DEVICE_UV },
  { label: '上报用户数', value: MetricSubType.SUB_TYPE_USER_UV },
];
export const DIMENSION_OPTIONS = [
  { label: 'APP版本', value: 'app_version', color: '#60DBB4' },
  { label: '系统版本', value: 'os_version', color: '#3385FF' },
  { label: '机型', value: 'model', color: '#52B7FF' },

  { label: '运营商', value: 'operator', color: '#60DBB4' },
  { label: '进程', value: 'process_name', color: '#3385FF' },
  { label: 'Bundle ID', value: 'bundle_id', color: '#52B7FF' },
];

export const DIMENSION_NAMES = [
  { label: '域名', value: 'domain' },
  { label: 'URL', value: 'peer_name' },
  // { label: '场景', value: 'stage' },
  { label: '网络库', value: 'traffic_type' },
];
